// @flow

import React, { useCallback, useState } from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import { flex, Color, hover } from 'styles';
import { Link } from 'components/Gui';

const Wrapper = styled.div`
  width: 100%;
`;

const Titles = styled.div`
  ${flex('flex-start', 'flex-start')};
  flex-wrap: wrap;
  ${({ border }) =>
    border &&
    css`
      padding-bottom: 8px;
      border-bottom: 1px solid ${Color.MARKETS_RED};
    `};
`;

const Title = styled.div`
  ${({ margin }) => margin && `border-right: 2px solid ${Color.MARKETS_RED}`};
  margin-right: 12px;
  padding-right: 16px;
  margin-bottom: 10px;

  button {
    text-transform: none;
    font-weight: ${({ active }) => (active ? 700 : 200)};
    font-size: 4rem;
    font-style: italic;
    ${hover('color', Color.BLACK_SOUL, Color.MARKETS_RED, true)};
  }
`;

const Text = styled.div`
  margin-top: 20px;
  width: 100%;

  p {
    margin-bottom: 30px;
    font-size: 2rem;
  }

  li {
    font-size: 2rem;
    span {
      color: ${Color.MARKETS_RED};
      font-weight: 700;
      padding-right: 4px;
    }
  }

  ul {
    margin-bottom: 30px;
    list-style: none;
  }

  .button {
    margin-bottom: 16px;
  }
`;

type Props = {
  border?: boolean,
  setIndex?: () => {},
  content: {
    title: string,
    text: Node,
  }[],
};

const Toggle = ({ border = false, content, setIndex, ...rest }: Props) => {
  const [showing, setShowing] = useState(0);
  const onClick = useCallback(
    index => {
      setShowing(index);
      if (setIndex) setIndex(index);
    },
    [setShowing, setIndex]
  );
  return (
    <Wrapper {...rest}>
      <Titles border={border}>
        {content.map(({ title }, index) => (
          <Title key={`ToggleTitle-${index}`} active={index === showing} margin={index !== content.length - 1}>
            <Link onClick={() => onClick(index)}>{title}</Link>
          </Title>
        ))}
      </Titles>
      <Text>{content[showing].text}</Text>
    </Wrapper>
  );
};

export default Toggle;
